import React from "react";
import FooterMainFlower from "./FooterMainFlower";

const FooterMainContainerFlower = React.memo(({...props }) => {
  return <FooterMainFlower {...props } />;
});

export default FooterMainContainerFlower;
